import React, { useState } from "react";
import { Modal } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Image from "next/image";
const useStyles = makeStyles((theme) => ({
  rule_info: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "812px",
    background: "#fff",
    textAlign: "center",
    margin: "auto",
    padding: "40px 40px",
    borderRadius: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    "@media(max-width:767px)": {
      width: "90%",
      maxHeight: "615px",
      padding: "15px",
    },
  },
  top_logo: {
    marginBottom: "30px",
    "@media(max-width:480px)": {
      width: "100px",
    },
  },
  title: {
    marginBottom: "30px",
    fontSize: "24px",
    fontWeight: "600",
    "@media(max-width:767px)": {
      marginBottom: "15px",
    },
  },
  description: {
    fontSize: "14px",
    lineHeight: "21px",
    width: "100%",
    maxWidth: "690px",
    "& p": {
      marginBottom: "37px",
    },
    "& ol": {
      textAlign: "left",
    },
    "& ol li": {
      marginBottom: "20px",
    },
    "@media(max-width:767px)": {
      maxHeight: "250px",
      overflow: "auto",
    },
  },
  formCheckLabel: {
    marginBottom: "0",
    fontSize: "12px",
    marginLeft: "18px",
    paddingTop: "5px",
  },
  close: {
    zIndex: "2",
    position: "absolute",
    top: "15px",
    right: "15px",
  },
  btn: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    width: "100%",
    maxWidth: "346px",
    color: "#fff",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    marginTop: "20px",
    borderRadius: "10px",
    height: "56px",
    textTransform: "capitalize",
    border: "none",
    margin: "auto",
  },
}));

const CommunityRuleAgreeModal = ({
  open,
  communityRules,
  agree,
  isExclusive,
}) => {
  const [checked, setChecked] = useState(false);
  const handleJoin = () => {
    agree(checked);
    setChecked(false);
  };
  const handleClose = () => {
    agree(false);
    setChecked(false);
  };
  const classes = useStyles();
  return (
    <>
      <Modal open={open} onClose={handleClose} disableScrollLock={true}>
        <div className={classes.rule_info}>
          <button
            type="button"
            className={classes.close + " close"}
            data-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <span aria-hidden="true">
              <Image
                src="/images/community/modal-close.svg"
                width="24px"
                height="24px"
                alt="modal close image"
              />
            </span>
          </button>
          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              src="/images/community/rule-logo.svg"
              className={classes.top_logo}
              alt="..."
            />
            {isExclusive && (
              <img
                src="/images/community/lock.svg"
                alt=""
                style={{
                  position: "absolute",
                  bottom: "25px",
                  right: "0",
                  maxWidth: "50px",
                }}
              />
            )}
          </div>
          {!isExclusive && (
            <h5 id="exampleModalLongTitle" className={classes.title}>
              Welcome to the FanTiger Community!
            </h5>
          )}
          {isExclusive && (
            <h5 id="exampleModalLongTitle" className={classes.title}>
              NFT locked Community
            </h5>
          )}
          <div
            className={classes.description}
            dangerouslySetInnerHTML={{
              __html: communityRules ? communityRules : "",
            }}
          ></div>
          <div className="term">
            <input
              type="checkbox"
              className="form-check-input"
              id="exampleCheck1"
              checked={checked}
              value={checked}
              style={{ marginLeft: "0", marginRight: "1rem", marginTop: "7px" }}
              onChange={() => setChecked(!checked)}
            />
            <label className={classes.formCheckLabel} htmlFor="exampleCheck1">
              I agree to the{" "}
              <span
                style={{ cursor: "pointer" }}
                onClick={() => window.open("/terms", "_blank")}
              >
                {" "}
                Terms & Conditions{" "}
              </span>{" "}
              to join the Community.
            </label>
          </div>
          <button
            type="button"
            className={classes.btn}
            disabled={!checked}
            onClick={handleJoin}
          >
            I Agree
          </button>
        </div>
      </Modal>
    </>
  );
};

export default CommunityRuleAgreeModal;
